import * as Sentry from '@sentry/sveltekit';

import { envString, isDev } from './utils/envs';
let replayConfig = {};
Sentry.init({
  dsn: 'https://9e12060cb8871490ba8aac9f7347a147@sentry.kelp.digital/9',
  release: import.meta.env.VITE_SENTRY_RELEASE_VERSION,
  enabled: !isDev(),
  debug: isDev(),
  environment: envString(),
  replaysOnErrorSampleRate: 1,
  tracesSampleRate: 1,
  sampleRate: 1,
  replaysSessionSampleRate: 1,
  // If you don't want to use Session Replay, just remove the line below:
  integrations: [
    Sentry.browserProfilingIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(replayConfig)
  ],
  beforeSend: (event) => {
    console.debug('event', event);
    if (event.exception) {
      if (event.extra) {
        console.debug('extra', event.extra);
        const extra = event.extra as {
          __serialized__:
            | {
                body: {
                  message: string;
                  status: number;
                };
                status: number;
              }
            | undefined;
        };
        if (extra.__serialized__ && extra.__serialized__.status !== 401) {
          // Sentry.showReportDialog({ eventId: event.event_id });
        }
      }
    }
    return event;
  }
});
